<div class="login-container">
  <h2>Login</h2>
  <form (ngSubmit)="onLoginClick()">
    <div class="form-group">
      <label for="email">Email</label>
      <input type="email" id="email" class="form-control" placeholder="Enter your email" required
        [(ngModel)]="email" name="email" />
      </div>
      <div class="form-group pb-2">
        <label for="password">Password</label>
        <input type="password" id="password" class="form-control" placeholder="Enter your password" required
          [(ngModel)]="password" name="password" />
        </div>

        @if (error) {
          <div class="alert alert-danger">{{ error }}</div>
        }

        <button type="submit" class="btn btn-primary" [disabled]="loading">
          {{ loading ? 'Logging in...' : 'Login' }}
        </button>
      </form>
    </div>